import React from "react";

const getBadgeClass = (score) => {
  const num = parseInt(score);
  if (num >= 95) return { bg: "#d1fae5", color: "#065f46" };
  if (num >= 90) return { bg: "#fef3c7", color: "#92400e" };
  return { bg: "#fee2e2", color: "#991b1b" };
};

function AssetCardStep({ data }) {
  const badge = getBadgeClass(data.score_badge);
  return (
    <div className="flex items-center justify-between border border-gray-200 rounded-lg px-4 py-3 bg-white">
      <div>
        <p className="font-mono text-sm font-bold text-blue-600">{data.title}</p>
        <p className="text-xs text-indigo-500 mt-0.5">{data.path}</p>
      </div>
      <span
        className="text-xs font-bold px-2 py-1 rounded-md whitespace-nowrap"
        style={{ backgroundColor: badge.bg, color: badge.color }}
      >
        {data.score_badge}
      </span>
    </div>
  );
}

function ProgressBarStep({ data }) {
  const value = data.value ?? 0;
  const suffix = data.value_suffix ?? "";

  return (
    <div className="flex items-center gap-3">
      <div className="flex-1 bg-gray-200 rounded-full h-3 overflow-hidden">
        <div
          className="h-3 rounded-full transition-all duration-700"
          style={{
            width: `${value}%`,
            background: "linear-gradient(90deg, #34d399, #059669)",
          }}
        />
      </div>
      <span className="text-sm font-bold text-gray-800 w-12 text-right">
        {value}{suffix}
      </span>
    </div>
  );
}

function DetailCardStep({ data }) {
  return (
    <div className="flex flex-col gap-2">
      {data.map((row, i) => (
        <div key={i} className="flex items-center gap-2">
          <span className="text-xs text-gray-400 w-28 shrink-0">{row.label}</span>
          <span className="text-sm font-medium text-gray-800">{row.value}</span>
        </div>
      ))}
    </div>
  );
}

export default function StepsChartResponse({ data }) {
  const steps = data?.steps ?? [];

  return (
    <div className="flex flex-col gap-5 mt-2 w-full">
      {steps.map((step, i) => (
        <div key={i}>
          {/* Step Title */}
          <p className="text-[11px] font-bold text-indigo-600 uppercase tracking-widest mb-2">
            {step.title}
          </p>

          {/* Step Content */}
          {step.type === "ASSET_CARD" && <AssetCardStep data={step.data} />}
          {step.type === "PROGRESS_BAR" && <ProgressBarStep data={step.data} />}
          {step.type === "DETAIL_CARD" && <DetailCardStep data={step.data} />}
        </div>
      ))}
    </div>
  );
}